// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"d6556ae5","453":"fd3f2788","627":"3031d88f","738":"2e1faedf","923":"32d33c78"}[chunkId] + ".chunk.js";
};